<template>
  <div class="product-filters">
                  
    <div class="filter">
      <b 
        class="filter__name" 
        data-bs-toggle="collapse" 
        data-bs-target="#filter-categories" 
        role="button" 
        aria-expanded="true" 
        aria-controls="filter-categories" 
      >
        Product Type 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#464646" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"/></svg>
      </b>
      <ul class="collapse show" id="filter-categories">
        <li 
          v-bind:class="{ active: ! filters.category }" 
          v-on:click="clearFilter('category')" 
        >All</li>
        <li 
          v-for="category in categories" 
          v-bind:class="{ active: filters.category == category.id }" 
          v-on:click="setFilter('category', category.id)" 
          role="button"
        >{{ category.name }} ({{ countCategoryProducts(category) }})</li>
      </ul>
    </div> <!-- .filter -->
    
    <div class="filter">
        <b 
          class="filter__name collapsed" 
          data-bs-toggle="collapse" 
          data-bs-target="#filter-brands" 
          role="button" 
          aria-expanded="false" 
          aria-controls="filter-brands"
        >
          Brand 
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#464646" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"/></svg>
        </b>
        <ul class="collapse" id="filter-brands">
          <li 
            v-bind:class="{ active: ! filters.brand }" 
            v-on:click="clearFilter('brand')"
            >All</li>
          <li 
            v-for="brand in brands" 
            v-bind:class="{ active: filters.brand == brand.id }" 
            v-on:click="setFilter('brand', brand.id)" 
            role="button"
          >{{ brand.name }} ({{ countBrandProducts(brand) }})</li>
        </ul>
    </div> <!-- .filter -->
    
    <!-- 
    <div class="filter">
      <b 
        class="filter__name collapsed" 
        data-bs-toggle="collapse" 
        data-bs-target="#filter-flavors" 
        role="button" 
        aria-expanded="false" 
        aria-controls="filter-flavors"
      >
        Flavor 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#464646" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"/></svg>
      </b>
      <ul class="collapse" id="filter-flavors">
        <li 
          v-bind:class="{ active: ! filters.flavor }" 
          v-on:click="clearFilter('flavor')"
        >All</li>
        <li 
          v-for="flavor in flavors" 
          v-bind:class="{ active: filters.flavor == flavor }" 
          v-on:click="setFilter('flavor', flavor)" 
          role="button"
        >{{ flavor }}</li>
      </ul>
    </div>
    
    <div class="filter">
      <b 
        class="filter__name collapsed" 
        data-bs-toggle="collapse" 
        data-bs-target="#filter-sizes" 
        role="button" 
        aria-expanded="false" 
        aria-controls="filter-sizes"
      >
        Size 
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#464646" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"/></svg>
      </b>
      <ul class="collapse" id="filter-sizes">
        <li 
          v-bind:class="{ active: ! filters.size }" 
          v-on:click="clearFilter('size')"
        >All</li>
       <li 
          v-for="size in sizes" 
          v-bind:class="{ active: filters.size == size }" 
          v-on:click="setFilter('size', size)" 
          role="button"
        >{{ size }}</li>
      </ul>
    </div>
    -->
    
    <hr>
    
    <span class="btn-reset" role="button" v-on:click="resetFilters()"><i class="fa fa-refresh"></i> Reset Filters</span>
  </div> <!-- .product-filters -->
</template>

<script>
import store from '../store.js'
import { Collapse } from 'bootstrap'

export default {
  computed: {
    filters() {
      return store.state.productFilters
    },
    brands() {
      return store.state.productBrands
    },
    categories() {
      return store.state.productCategories
    },
    flavors() {
      return store.state.productFlavors
    },
    sizes() {
      return store.state.productSizes
    },
  },
  methods: {
    setFilter(filter, val) {
      store.dispatch('setProductFilter', { filter: filter, val: val })
    },
    clearFilter(filter) {
      store.dispatch('setProductFilter', { filter: filter, val: null })
    },
    resetFilters() {
      store.dispatch('resetProductFilters')

      document.querySelectorAll('.filter:not(:first-child) .collapse').forEach(filter => {
        Collapse.getInstance(filter).hide()
      })

      document.querySelectorAll('.filter:first-child .collapse').forEach(filter => {
        Collapse.getInstance(filter).show()
      })
    },
    countCategoryProducts(category) {
      return store.getters.countCategoryProducts(category)
    },
    countBrandProducts(brand) {
      return store.getters.countBrandProducts(brand)
    }
  }
}
</script>
